import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
  useLocation(); // re-renders Navbar on every route change, keeping session state fresh
  const navigate = useNavigate();
  const isLoggedIn = !!sessionStorage.getItem('sessionData');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('sessionData');
    setDropdownOpen(false);
    navigate('/');
  };

  return (
    <nav className="navbar">
      <Link className="nav-brand" to="/">Runaroo</Link>
      <div className="nav-links">
        {isLoggedIn && (
          <div className="profile-menu" ref={dropdownRef}>
            <Link className="nav-link" to="/profile">Profile</Link>
            <button className="profile-arrow" onClick={() => setDropdownOpen(v => !v)}>▾</button>
            {dropdownOpen && (
              <div className="profile-dropdown">
                <button className="dropdown-item" onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        )}
        {isLoggedIn && <Link className="nav-link" to="/support">Support</Link>}
        <Link className="nav-link" to="/privacy">Privacy Policy</Link>
      </div>
    </nav>
  );
}

export default Navbar;
